import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DropdownNavigationItem } from '@common-modules/navigation/models/dropdown-navigation-item';

import { TabDetailPanelParameters } from '@common-modules/dependencies/navigation/tab-detail-panel-parameters';
import { AuthenticationService } from '@common-modules/shared/auth/services/authentication.service';
import { BasePageComponent } from '@common-modules/shared/component/base-page.component';
import { GridSetting } from '@common-modules/shared/constants/grid.constants';
import { GridSettingsService } from '@common-modules/shared/core/grid/grid-settings.service';
import { DataBindingFilters } from '@common-modules/shared/filters/component-filters/data-binding-filters';
import { GroupDto } from '@common-modules/shared/model/roles/group.dto';
import { RolesService } from '@common-modules/shared/roles/roles.service';
import { GenericGridComponent } from '@common-modules/wlm-grid/generic-grid/generic-grid.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DialogService } from '@progress/kendo-angular-dialog';

const COMPONENT_SELECTOR = 'ct-groups-page';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './groups-page.component.html',
  styleUrl: './groups-page.component.scss',
  standalone: false,
})
export class GroupsPageComponent2 extends BasePageComponent implements OnInit, OnDestroy {
  gridData = [
    { groupId: 21, groupName: 'Administrator', groupDescription: 'Only Admin rights' },
    { groupId: 19, groupName: 'CustomerSupport', groupDescription: 'LeakageCustomerSupportTeam' },
    { groupId: 7, groupName: 'DeliveryAnalyst', groupDescription: 'DeliveryAnalyst' },
    { groupId: 26, groupName: 'emergency team', groupDescription: 'emergency team' },
    { groupId: 27, groupName: 'GroupTest', groupDescription: 'Test' },
    { groupId: 5, groupName: 'LeakageAnalyst', groupDescription: 'LeakageAnalyst' },
  ];

  @ViewChild(GenericGridComponent) public groupsGrid: GenericGridComponent;

  isSaving = false;
  gridSettings: GridSetting;
  gridFiltersForBinding: DataBindingFilters;
  selectedGroup: GroupDto;
  gridName = 'Groups';

  public get titleTranslationKey(): string {
    return 'title';
  }

  public get persistencyArea(): string {
    return this.pageCrud;
  }
  public get pageCrud(): string {
    return 'GroupPageCrud';
  }
  public get navigations(): DropdownNavigationItem[] {
    return [];
  }

  constructor(
    private _gridService: GridSettingsService,
    private _dialogService: DialogService,
    private _rolesService: RolesService,
    private _authService: AuthenticationService
  ) {
    super();
    // _gridService.getGridSettingsByName(this.gridName).subscribe({
    //   next: (gridSettings) => {
    //     if (gridSettings) {
    //       this.gridSettings = gridSettings;
    //     }
    //   },
    // });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadGrid();
    this.populateGridSettings();
  }

  private populateGridSettings(): void {
    this.gridSettings = {
      familyIdFilterName: 'hierarchyElementsIds',
      count: true,
      pageSize: 10,
      pageable: {
        type: 'input',
        pageSizes: [10, 20, 50],
      },
      sortable: true,
      filterable: 'menu',
      resizable: true,
      reorderable: true,
      navigatable: true,
      selectable: {
        enabled: true,
        checkboxOnly: true,
      },
      showZoneColumns: false,
      showSelectAllColumn: false,
      excelFileName: 'Groups',
      service: 'RolesService',
      backgroundColorMethodName: null,
      backgroundColorKeyField: null,
      fontWeightMethodName: null,
      gridColumnSettings: [
        {
          field: 'groupName',
          localeTitle: {
            es: 'Nombre de Grupo',
            'en-GB': 'Group Name',
            tr: 'Grup Adı',
            it: 'Nome Gruppo',
            'zh-CN': '团队名字',
          },
          title: 'Group Name',
          type: 'text',
          visible: true,
          width: 150,
        },
        {
          field: 'groupDescription',
          title: 'Group Description',
          localeTitle: {
            es: 'Descripción de Grupo',
            'en-GB': 'Group Description',
            tr: 'Grup Açıklaması',
            it: 'Descrizione Gruppo',
            'zh-CN': '团体简介',
          },
          type: 'text',
          visible: true,
          width: 150,
        },
      ],
      selectByFieldName: null,
      cacheOpts: {
        avoid: true,
      },
      sort: [
        {
          field: 'groupName',
          dir: 'asc',
        },
      ],
      buttons: {
        show: ['clear_grid_filters', 'manage_columns'],
      },
      selectionPersistency: false, // Añadir esta propiedad
      hideHeader: false, // Añadir esta propiedad
      utcDates: false, // Añadir esta propiedad
    };
  }

  getSelectedGroup(item: GroupDto) {
    this.selectedGroup = item;
  }

  mapInitParameters(parameters: TabDetailPanelParameters) {
    throw new Error('Method not implemented.');
  }
  init(): void {
    throw new Error('Method not implemented.');
  }

  private loadGrid() {
    this.gridFiltersForBinding = new DataBindingFilters();
    this.groupsGrid?.reloadGrid();
  }
}
